import { render } from "./projects-list-page.vue?vue&type=template&id=45a76962&scoped=true"
import script from "./projects-list-page.vue?vue&type=script&lang=js"
export * from "./projects-list-page.vue?vue&type=script&lang=js"

import "./projects-list-page.vue?vue&type=style&index=0&id=45a76962&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a76962"]])

export default __exports__